import { getBrandCapabilityStatus } from '@/features/hestia/queries/useBrandCapabilities'

/** Namespace + capability identifying the website job board in the capabilities payload. */
export const JOB_BOARD_CAPABILITY = [
  'website-builder',
  'website-job-board',
] as const

/**
 * Whether the website job board is gated for the active brand: the MiB display flag
 * is on AND the backend reports the capability disabled. The flag value is passed in
 * so callers can source it from either the static UnleashClient (nav map) or the
 * reactive flag composable (components).
 * @param flagEnabled
 */
export const isJobBoardGated = (flagEnabled: boolean): boolean =>
  flagEnabled &&
  getBrandCapabilityStatus(...JOB_BOARD_CAPABILITY) === 'disabled'
